<template>
    <vx-card :title='$t("BasicSettings")' collapse-action>
        <p class="mt-6">{{$t("MinimalInvoicingUnit")}}</p>
        <vs-input type="number" v-model="settings['minimal_invoicing_unit']" style="width: 100%"></vs-input>
        <vs-divider></vs-divider>

        <p class="mt-6">{{$t("WorkDays")}}</p>
        <vs-select autocomplete multiple class="selectExample w-full" v-model="selectedWorkDays">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in [{value: 1, text: this.$t('Monday')}, {value: 2, text: this.$t('Tuesday')}, {value: 3, text: this.$t('Wednesday')}, {value: 4, text: this.$t('Thursday')}, {value: 5, text: this.$t('Friday')}, {value: 6, text: this.$t('Saturday')}, {value: 0, text: this.$t('Sunday')}]" />
        </vs-select>
        <p class="mt-6">{{$t("TimeLockDay")}}</p>
        <vs-input type="number" v-model="settings['month_lock_day']" style="width: 100%"></vs-input>

        <vs-divider class="mt-6"></vs-divider>
        <p class="mt-6">{{$t("VacationLockDay")}}</p>
        <vs-input type="number" v-model="settings['vacation_lock_day']" style="width: 100%"></vs-input>
        <p class="mt-6">{{$t("VacationLockMonth")}}</p>
        <vs-input type="number" v-model="settings['vacation_lock_month']" style="width: 100%"></vs-input>
        <vs-divider class="mt-6"></vs-divider>

        <p class="mt-6">{{$t("NotificationStartHour")}}</p>
        <vs-input type="number" v-model="settings['notification_start_time']" style="width: 100%"></vs-input>
        <p class="mt-6">{{$t("NotificationEndHour")}}</p>
        <vs-input type="number" v-model="settings['notification_end_time']" style="width: 100%"></vs-input>
        <vs-divider class="mt-6"></vs-divider>

        <p class="mt-6">{{$t("Country")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="settings['country_code']">
            <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in this.countryList" />
        </vs-select>
        <p class="mt-6">{{$t("Timezone")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="settings['timezone']">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in this.timezones" />
        </vs-select>
        <p class="mt-6">{{$t("RegistrationTerminalClient")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="settings['registration_terminal_client']">
            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
        </vs-select>
        <p class="mt-6">{{$t("RegistrationTerminalBranchOffice")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="settings['registration_terminal_branch_office']">
            <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
        </vs-select>
        <p class="mt-6">{{$t("RegistrationTerminalWorkType")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="settings['registration_terminal_work_type_id']">
            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTypeMap" />
        </vs-select>
        <vs-divider></vs-divider>

        <p class="mt-6">{{$t("HeadquartersAddress")}}</p>
        <vs-input v-model="settings['home_address']" style="width: 100%"></vs-input>

        <vs-button color="success" type="border" class="mt-6" @click="editCompanySettings">{{$t("Save")}}</vs-button>

    </vx-card>
</template>
<script>

    import countryList from './countryList'
    import timezoneList from "./timezoneList";

    export default {

        data() {
            return {

                settings: {
                    registration_terminal_client: 0,
                },
                countryList: countryList.countryList,
                timezones: timezoneList.zones,
                selectedWorkDays: [],

                branchOffices: [{}],
                workTypes: [],

            }
        },
        watch: {
            'settings.registration_terminal_client': function () {
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.settings.registration_terminal_client + "/branch_offices")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        let found = false;
                        for(let x = 0; x < thisIns.branchOffices.length; x++){
                            if(thisIns.branchOffices[x].id === thisIns.settings['registration_terminal_branch_office']) found = true;
                        }

                        if(!found) thisIns.settings['registration_terminal_branch_office'] = thisIns.branchOffices[0].id;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        methods: {
            updateCompanySettings() {
                const thisIns = this;
                this.$http.get('/api/v1/settings/basic')
                    .then(function (response) {
                        thisIns.settings = response.data;
                        thisIns.selectedWorkDays = [...response.data.work_days]
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/work_type/')
                    .then(function (response) {
                        thisIns.workTypes = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editCompanySettings(){
                const thisIns = this;

                this.settings.work_days = [...this.selectedWorkDays];
                this.settings['minimal_invoicing_unit'] = Number(this.settings['minimal_invoicing_unit']);
                this.settings['minimum_work_time_day'] = Number(this.settings['minimum_work_time_day']);
                this.settings['month_lock_day'] = Number(this.settings['month_lock_day']);
                this.settings['vacation_lock_day'] = Number(this.settings['vacation_lock_day']);
                this.settings['vacation_lock_month'] = Number(this.settings['vacation_lock_month']);
                this.settings['notification_start_time'] = Number(this.settings['notification_start_time']);
                this.settings['notification_end_time'] = Number(this.settings['notification_end_time']);
                this.settings['registration_terminal_client'] = Number(this.settings['registration_terminal_client']);
                this.settings['registration_terminal_branch_office'] = Number(this.settings['registration_terminal_branch_office']);
                this.settings['registration_terminal_work_type_id'] = Number(this.settings['registration_terminal_work_type_id']);

                this.$http.put('/api/v1/settings/basic/', this.settings)
                    .then(function () {
                        thisIns.updateCompanySettings();
                        thisIns.$vs.notify({
                            title:'Success',
                            position:'top-right',
                            text: thisIns.$t("Saved"),
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        computed: {
            workTypeMap: function () {

                let types = {};
                for(let x = 0; x < this.workTypes.length; x++){
                    types[this.workTypes[x].id] = this.workTypes[x];
                }
                return types

            },
        },
        created() {
            this.updateCompanySettings();
        },
    }

</script>
